import * as _  from 'lodash'

class TextUtils {

  static padStart(sString: string, length: number, padString: string) {
    var str = sString;
    while (str.length < length)
      str = padString + str;
    return str;
  }

  static padEnd(sString: string, length: number, padString: string) {
    var str = sString;
    while (str.length < length)
      str = str + padString;
    return str;
  }

  static splitConservingWords(sString: string, maxLength: number): string[] {
    let returnValue: string[] = []
    let sSrc = sString || ''
    if (_.isEmpty(sString)) return []

    if (sSrc.length <= maxLength) {
      return [sSrc]
    }

    let subLine = sSrc.substring(0, maxLength)
    let secondPart: string = ''
    let lastSpaceIdx = subLine.lastIndexOf(" ")
    if (lastSpaceIdx == -1) {
      secondPart = sSrc.substring(maxLength)
      returnValue.push(subLine)
    } else {
      //
      let firstPart = sSrc.substring(0, lastSpaceIdx)
      secondPart = sSrc.substring(lastSpaceIdx)
      if (!_.isEmpty(firstPart)) {
        returnValue.push(firstPart)
      }
    }

    if (!_.isEmpty(secondPart)) {
      if (secondPart.length <= maxLength) {
        returnValue.push(secondPart)
      } else {
        _.forEach(TextUtils.splitConservingWords(secondPart, maxLength), (aStr) => {
          returnValue.push(aStr)
        })

      }

      return returnValue
    }
  }

  static trimToLength(sString: string, maxLength: number) : string {
    return TextUtils.splitConservingWords(sString, maxLength).join("");
  }

  static convertToValidFileName(sString: string): string {
    if(!sString)
      return ""

    return sString.replace(/ *[\\~#%&*{}\/:<>?|\"-]+ */g, " ");
  }

}


export {TextUtils}